<template>
  <div class="reflink-box card" :data-notification-id="id">
    <div class="card-body p-3">
      <div class="d-flex justify-content-between align-items-center">
        <div class="reflink-icon">
          <img :src="reflink.avatarUrl" :alt="reflink.name" />
        </div>
        <div>
          <h5 class="card-title fw-bolder mb-0">
            {{ reflink.name }}
          </h5>
          <p class="card-text">{{ reflink.description }}</p>
        </div>
        <div class="mt-4 fs-3">
          <p v-if="reflink.discount > 0" class="text-end text-danger">
            -{{ reflink.discount }}%
          </p>

          <fa-icon
            v-if="isDismissable"
            class="position-absolute top-0 end-0 me-2 mt-2 fs-2 text-danger cursor-pointer"
            :icon="faCircleXmark"
            @click="dismissNotification"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Reflink } from 'gportal-grpc/gportal/api/marketing/v1/reflink_pb';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';

const props = defineProps({
  reflink: {
    type: Object as PropType<Reflink>,
    required: true,
  },
  isDismissable: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
});

const emit = defineEmits<{
  (e: 'dismissed'): void;
}>();

const dismissNotification = () => emit('dismissed');

const id = `reflink-${props.reflink.reflink}`;
</script>

<style scoped lang="scss">
@import 'gportal-theme/scss/colors';

.reflink {
  &-box {
    background-image: $gradient-background;
    border: 0;
  }

  &-icon {
    img {
      width: 60px;
      height: 60px;
      margin-right: 1rem;
    }
  }
}
</style>
